import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './InfiniteProgress.scss?inline';

@customElement('app-infinite-progress')
export class InfiniteProgress extends LitElement {
    static styles = [unsafeCSS(styles)];

    @property({ type: Boolean, reflect: true }) paused = false;

    render() {
        return html`
            <div class="track" role="progressbar" aria-busy="true" aria-label="Cargando">
                <div class="bar"></div>
                <div class="bar bar--2"></div>
            </div>
        `;
    }
}
